import axios from "axios";
import config from "../../../../config/config";

export const SEARCH_TRAVEL_URL = config.baseUrl + "travel/index/search";
export const GET_TRAVEL_DETAILS =
  config.baseUrl + "travel/detail/getTravelDetail";
export const BUY_TICKET = config.baseUrl + "ticket/buyTicket";
export const GET_TICKET_INVOICE = config.baseUrl + "ticket/getTicketInvoice";
export const PAY_BY_WALLET = config.baseUrl + "pay/payByCredit";
export const PAY_BY_GATEAWAY = config.baseUrl + "pay/mellat/";
export const Charge_Wallet = config.baseUrl + "pay/chargeWallet";
const CONTENT_URL = config.baseUrl + "ContentTravelLanding";

export function search_travel(sourceTownshipId, destTownshipId, travelDate, seatCount = 1) {
  return axios.get(SEARCH_TRAVEL_URL, {
    params: {
      sourceTownshipId,
      destTownshipId,
      travelDate,
      seatCount
    },
  });
}

export function getTravelDetails(sourceTownshipId, destTownshipId, travelId, seatCount = 1) {
  return axios.get(GET_TRAVEL_DETAILS, {
    params: {
      sourceTownshipId,
      destTownshipId,
      travelId,
      seatCount
    },
  });
}

export function buyTicket(data, token) {
  return axios.post(BUY_TICKET, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function getTicketInvoice(params, token) {
  return axios.get(GET_TICKET_INVOICE, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
}

export const payByWallet = (data, token) => {
  return axios.post(PAY_BY_WALLET, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const payByGateaway = (id) => {

  window.location = config.baseUrl + 'pay/mellat/' + id;
};

export const chargeWallet = (token, data) => {
  return axios.post(Charge_Wallet, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const contentLanding = (data) => {
  return axios.get(CONTENT_URL, data, {
    headers: { "Content-Type": "application/json"},
  });
};